export function searchRemote(): string {
  return `
    remote {
      date
      placeholder
      searchAction
      title
    }
  `;
}
export function resortStartingPrice(): string {
  return `
    startingPrice {
      allInclusive
      bookingButtonLabel
      dateFormat
      departureCityLabel
      departureDateLabel
      durationUnit
      endDateLabel
      longDateFormat
      roomOnly
      seeDetails
      stayDeparture
    }
  `;
}
export function resort(appContext: AppContext): string {
  const { cmsContent = '', cmsRelease = '' } = appContext;
  const cmsArgs = `content : "${cmsContent}", release : "${cmsRelease}"`;
  return `
    resort {
      season(${cmsArgs}) {
        winter
        summer
        button
      }
      ${resortStartingPrice()}
      pricePopin {
        buttonLabel
        buttonCruiseLabel
        buttonTourLabel
        priceIsLabel
        roomAvailability
        startingPriceDescriptionWithoutTransport
        startingPriceDescriptionWithTransport
        taxeAndFees
      }
      tripadvisor {
        menubar {
          reviews
        }
      }
      moreResultsLabels {
        label
        buttonLabel
      }
    }
  `;
}
export function price(): string {
  return `
    price {
      format{
        from
        instead
        flightIncluded
        unitPerTrip
        unitPerNight
        unitTotalPerTrip
        unitTotalPerTripIndicative
        viewRates
      }
    }
  `;
}
export function faceting(): string {
  return `
    common {
      dateFormatPlaceholder
      loadLess
      loadMore
      selectedCriteriasLabel {
        _1
        n
      }
    }
    booking {
      form {
        dateFormat
        dayPlaceholder
        monthPlaceholder
        yearPlaceholder
        departureDateTitle
        selectAdultsLabels {
          _1
          n
        }
        selectChildrenLabels {
          _1
          n
        }
      }
      editCriteria {
        validateCriteria
      }
    }
    faceting {
      intro
      facetClear
      oneResortThatMatchYourCriteria
      nbResortsThatMatchYourCriteria
      viewResorts
      searchTitle
      searchLinkLabel
      suggestedRequests {
        title
        items {
          label
          url
        }
      }
      reset
      validate
      when {
        title
        subTitle
        durations
        duration
        from
        bestPrice
        lastAvailability
        notAvailable
        departureDateTitle
        arrivalDateTitle
        durationSingular
        durationPlural
        reinsurance
        pricesBasedOn
      }
      who {
        addChildcare
        adults
        ageComment
        ageSectionChildcareSubtitle
        ageSectionSubtitle
        birthdatePlaceholder
        kids
        kidsAgeLimit
        kidsBirthdate
        subTitle
        title
        withKidsFacetLabel
        withChildcareFacetLabel
      }
      compare {
        selectResort
        selected
        dateAndTransportMandatory
        unavailableThumbnail
        warningMessage
        title
        buttonLabel
        cancelLabel
        collapseLabel
        expandLabel
        dropzoneLabel
      }
      topCountries {
        enabled
        title
        items {
          id
        }
      }
      transport {
        comment
        defaultDepartureCityOnlyForDefaultTransportation
        departingFrom
        departureCities {
          reinsurance
        }
        noTransportNeededMobile
        selectPlaceholder
        subTitle
        titleFrom
        transportNeededMobile
      }
      availabilities {
        childcare
        enterBirthdate
        years
        year
        months
        noChildcare
        noChildcareFrom0
        available
        unavailable
        unknown
        urgentizationSingular
        urgentizationPlural
      }
      showFilterCTA
      hideFilterCTA
      comfort {
        title
      }
    }`;
}
export function birthdatePopin() {
  return `birthdatePopin {
    title
    subtitle
    confirm
    child
    skip
  }`;
}
export function common() {
  return `common {
    close
    continue
    included
    allInclusive
  }`;
}
export function priceRemote() {
  return `${faceting()}
  ${common()}
  booking {
    form {
      selectAdultsLabels {
        _1
        n
      }
      selectChildrenLabels {
        _1
        n
      }
      selectDates
      selectParticipants
      selectTransports
      proposalsLoaderLabel
      errors {
        birthdayFormat
      }
    }
    priceCalendar {
      offers {
        bestPrice { label }
        urgentisation { label rateToDisplay }
      }
    }
  }
  price {
    format{
      from
      instead
      viewRates
      unitTotalPerTrip
      unitTotalPerTripIndicative
    }
  }
  priceRemote {
    openAllInclusiveDetails
    closeAllInclusiveDetails
    notAvailable
    notAvailableCTA
    notAvailableCTATransportation
    notAvailableTransportation
    priceForAll
    priceRemoteButton
    priceRemoteBeEntryButton
    linkToCalendar
    errors {
      birthdateError
      noAvailabilities
      notOnSale
      technicalError
      invalidCriteria
      noTransport
    }
    rateCounterProposalLabel
    optionHold {
      title
      description
      descriptionTransport
      highlight
    }
  }
  resort {
    startingPrice {
      allInclusive
    }
  }
  `;
}
